<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <h3>護生月曆</h3>
        <book-card-list :books="monthlyCalendars" :applicable="false" :downloadable="true"></book-card-list>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>護生曆卡</h3>
        <book-card-list :books="yearlyCards" :applicable="false" :downloadable="true"></book-card-list>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import BookCardList from '@/components/lists/BookCardList'
import BookApiService from '@/services/budaedu-api-services/book-api-service.js'

Vue.use(BookApiService)

export default {
  name: "calendar",
  data() {
    return {
      monthlyCalendars: [],
      yearlyCards: [],
    }
  },
  methods: {
    async fetchBooks(name_keyword, code_keyword) {
      const params = `filter[code][l]=${code_keyword}%&filter[chinese_name][l]=%${name_keyword}%&order=code,desc`;
      let items = await this.$bookApiService.query(params);
      
      const previewPromises = items.data.map(async (book) => {
        book.front_cover = await this.$bookApiService.getFrontCover(book, { url: 'img/common.jpg' });
      });
      await Promise.all(previewPromises);

      return items.data;
    }
  },
  async created() {
    this.monthlyCalendars = await this.fetchBooks('護生月曆', 'CH754');
    this.yearlyCards = await this.fetchBooks('護生曆卡', 'CH754');
    console.log(this.monthlyCalendars, this.yearlyCards)
  },
  components: {
    BookCardList
  }
}
</script>
